// API Configuration
// Always use the current page's origin for API calls.
// In both preview and deployed environments, the ingress routes /api/* to the backend.
// Using window.location.origin ensures no double /api prefix issues.
const ENV_URL = process.env.REACT_APP_BACKEND_URL || '';
let BACKEND_URL;
try {
  const envOrigin = new URL(ENV_URL).origin;
  // Always use just the origin (no path) to avoid double /api prefix
  BACKEND_URL = (window.location.origin === envOrigin) ? envOrigin : window.location.origin;
} catch (e) {
  BACKEND_URL = window.location.origin;
}
export const API = `${BACKEND_URL}/api`;

// Trigger map refresh event - call this after any data changes
export const triggerMapRefresh = () => {
  window.dispatchEvent(new CustomEvent('infopilot-data-changed'));
};

// Re-export the prohibited-content filter from the shared module so existing
// imports (`import { containsProhibitedContent } from '../../utils/api'`)
// continue to work without changes.
export {
  containsProhibitedContent,
  getProhibitedContentMessage,
  setProhibitedTopics,
  getProhibitedTopics,
  DEFAULT_PROHIBITED_TOPICS,
} from './prohibitedFilter';

export default API;
